/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ToggleLocationConnection/view.blocks to change it.
import CompleteSetupAction from './CompleteSetupAction/index'
import DisableConnectionForLocationAction from './DisableConnectionForLocationAction/index'
import React from 'react'
import SetupAutomations from './SetupAutomations/index'



/** @type {import('Simple/types.js').View} */
export default function ToggleLocationConnection({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection"
  
}) {
  return (<React.Fragment
>
<CompleteSetupAction
  viewPath={`${viewPath}/CompleteSetupAction`}
/>
<DisableConnectionForLocationAction
  viewPath={`${viewPath}/DisableConnectionForLocationAction`}
/>
<SetupAutomations
  viewPath={`${viewPath}/SetupAutomations`}
/>
{children}
</React.Fragment>)
}